import React, { useEffect } from 'react';
import styled from 'styled-components';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Content } from 'app/styles/content';
import { Helmet } from 'react-helmet-async';
import { TITLE_POSTFIX } from 'app/seo/seo.constants';
import { FPLink } from 'app/components/links/link';
import { captureSentryException } from 'app/services/sentryLogging';
const Wrapper = styled(Content).withConfig({
  componentId: "sc-wbqawk-0"
})(["&&&{padding:", " ", ";height:calc(100vh - ", ");margin:auto;}"], props => props.top ? props.top : SIZES[72], SIZES['16'], props => props.top ? props.top : SIZES[72]);
const Text = styled(Typography).withConfig({
  componentId: "sc-wbqawk-1"
})(["&&&{color:", ";}"], COLORS.darkGrey);
const TextLink = styled(FPLink).withConfig({
  componentId: "sc-wbqawk-2"
})(["&&&{text-decoration:none;color:", ";cursor:pointer;&:focus,&:hover{text-decoration:none;}&:visited,&:link,&:active{text-decoration:none;}}"], COLORS.fupaSecondary);
const ForbiddenPage = _ref => {
  let {
    top
  } = _ref;
  useEffect(() => {
    captureSentryException(new Error('Rate Limit of API fired.'), {
      extra: {
        location: location.pathname
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, {
    id: 'http-error-403',
    top: top,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "ForbiddenPage",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: "Anfrage wurde blockiert".concat(TITLE_POSTFIX),
    "data-sentry-element": "Helmet",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "display2",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, "Deine Anfrage wurde blockiert."), /*#__PURE__*/React.createElement(Text, {
    variant: "subheading",
    component: "p",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, "Erfahre hier, was der Grund daf\xFCr sein kann:", ' ', /*#__PURE__*/React.createElement(TextLink, {
    to: "https://support.fupa.net/support/solutions/articles/75000117879-blockierte-aufrufe-fehlermeldung-fehlerseite-",
    "data-sentry-element": "TextLink",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, "FAQ - Blockierte Aufrufe")), /*#__PURE__*/React.createElement(Text, {
    variant: "subheading",
    component: "p",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, "Nutze die Suchfunktion oder gehe zur", /*#__PURE__*/React.createElement(TextLink, {
    to: "/",
    "data-sentry-element": "TextLink",
    "data-sentry-source-file": "ForbiddenPage.tsx"
  }, " FuPa Startseite\uFE0F"), "."));
};
export default ForbiddenPage;